"use client";
import * as React$1 from "react";
//#region src/matchContext.tsx
var matchContext = React$1.createContext(void 0);
var dummyMatchContext = React$1.createContext(void 0);
//#endregion
export { dummyMatchContext, matchContext };

//# sourceMappingURL=matchContext.js.map